<template>
  <div class="topNav">
    <el-menu :default-active="activeIndex" mode="horizontal" @select="handleSelect" background-color="#4b5259" text-color="#fff" active-background-color="red" active-text-color="#7cc1eb">
      <el-menu-item index="home">HOME</el-menu-item>
      <el-menu-item index="loan">LOAN</el-menu-item>
      <el-menu-item index="borrower">BORROWER</el-menu-item>
      <el-menu-item index="earnings">EARNINGS</el-menu-item>
      <el-menu-item index="allreports">ALL REPORTS</el-menu-item>
      <el-menu-item index="library">LIBRARY</el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import HTTP_API from '@/utils/http-api'
export default {
  name: 'TopNav',
  data(){
    return{
      activeIndex: 'Home',
      lenderId:''
    }
  },
    watch: {
    $route (to, from) {
      this.activeIndex = to.name;
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      switch (key) {
        case 'home':
          if(this.$route.params.lenderId){
            this.lenderId = this.$route.params.lenderId
          }
          console.log("home")
          this.$router.replace({ name: 'home',params: {lenderId: this.lenderId}}).catch(err => {})
          break
        case 'loan':
          console.log("Loan")
          this.$router.replace({ name: 'loan' }).catch(err => {})
          break
        case 'borrower':
          console.log("Borrower")
          this.$router.replace({ name: 'borrower' })
          break
        case 'earnings':
          console.log("Earnings")
          this.$router.replace({ name: 'earnings' })
          break
        case 'allreports':
          console.log("AllReports")
          this.$router.replace({ name: 'allreports' })
          break
        case 'library':
          console.log("Library")
          this.$router.replace({ name: 'library' })
          break
      }
    },
    getTopNavInfo(){
      var vm = this
      HTTP_API.get('/base/topnavinfo')
      .then(response => {
        vm.lenderId = response.data
      })
      .catch(function (error) {
        console.log(error.response)
      })
    }
  },
  mounted(){
    this.activeIndex = this.$route.name;
    
  },created(){
    this.getTopNavInfo()
  }
}
</script>

<style scoped>
.topNav{
  margin-top: 89px;
  position: fixed;
  width: 100%;
  z-index: 1;
}

.el-menu-item{
  width:16.66%;
  text-align:center;
  font-weight: 700;
  font-size: 12.5px;
}

div >>> .el-menu-item.is-active{
  border-bottom-width: thick;
}

.el-menu--horizontal>>>.el-menu-item{
  height: 40px;
  line-height: 40px;
}
</style>
